// 黑哥们事件记录
import { useEffect, useState } from 'react';
import { List, Tag, Empty, Button, Space, App as AntApp } from 'antd';
import { ThunderboltFilled, RobotFilled } from '@ant-design/icons';
import { useStore } from '../store/account';
import type { HeigeEvent } from '../../shared/types';
export default function HeigeHistory() {
  const { getHeigeHistory, pollHeigeFeed, triggerHeige, refreshAccount } = useStore();
  const { message } = AntApp.useApp();
  const [history, setHistory] = useState<HeigeEvent[]>([]);
  const [polling, setPolling] = useState(false);
  const [triggering, setTriggering] = useState(false);
  const load = async () => {
    const h = await getHeigeHistory();
    setHistory(h);
  };
  useEffect(() => {
    load();
  }, []);
  const handleTestPoll = async () => {
    setPolling(true);
    try {
      const event = await pollHeigeFeed();
      if (event) {
        message.info(`检测到事件：${event.label}`);
      } else {
        message.info('未匹配到事件（当前新闻源没有"打砸抢"类）');
      }
    } finally {
      setPolling(false);
    }
  };
  const handleSimulate = async () => {
    setTriggering(true);
    try {
      const event: HeigeEvent = {
        id: `sim-${Date.now()}`,
        type: 'clash',
        label: '【模拟】大型暴力冲突事件',
        severity: 3,
        timestamp: Date.now(),
      };
      await triggerHeige(event);
      await load();
      await refreshAccount();
      message.success('模拟事件已触发');
    } finally {
      setTriggering(false);
    }
  };
  return (
    <div style={{ padding: 16 }}>
      {' '}
      <Space style={{ marginBottom: 12 }} wrap>
        {' '}
        <Button onClick={handleTestPoll} loading={polling}>
          {' '}
          🔍 立即扫描新闻源{' '}
        </Button>{' '}
        <Button type="primary" danger onClick={handleSimulate} loading={triggering}>
          {' '}
          🧪 模拟一次黑哥们事件{' '}
        </Button>{' '}
        <Button onClick={load}>刷新记录</Button>{' '}
      </Space>{' '}
      {history.length === 0 ? (
        <Empty
          image={Empty.PRESENTED_IMAGE_SIMPLE}
          description={
            <div>
              {' '}
              <div>暂无黑哥们事件</div>{' '}
              <div style={{ fontSize: 12, color: '#8b949e', marginTop: 4 }}>
                {' '}
                引擎会每 1 分钟扫描一次新闻源 <br /> 匹配到"打砸抢"类关键词自动触发 <br />{' '}
                你也可以点"模拟一次"立刻体验{' '}
              </div>{' '}
            </div>
          }
        />
      ) : (
        <List
          dataSource={history}
          renderItem={(e) => (
            <List.Item style={{ padding: '12px 0' }}>
              {' '}
              <Space direction="vertical" size={4} style={{ width: '100%' }}>
                {' '}
                <Space>
                  {' '}
                  <ThunderboltFilled
                    style={{ color: e.severity >= 4 ? '#ff4d4f' : '#faad14' }}
                  />{' '}
                  <strong>{e.label}</strong>{' '}
                  <Tag color={e.severity >= 4 ? 'red' : e.severity >= 3 ? 'orange' : 'default'}>
                    {' '}
                    严重度 {e.severity}/5{' '}
                  </Tag>{' '}
                </Space>{' '}
                <Space size="small" style={{ fontSize: 11, color: '#8b949e' }}>
                  {' '}
                  <RobotFilled />{' '}
                  <span>
                    {new Date(e.timestamp).toLocaleString('zh-CN', { hour12: false })}
                  </span>{' '}
                </Space>{' '}
              </Space>{' '}
            </List.Item>
          )}
        />
      )}{' '}
    </div>
  );
}
